require('./style.less');

var Marionette = require('marionette');
var markupPrintPreview = require('../../markup/previewIndicator/bundle');

module.exports = Marionette.ItemView.extend({

    className: 'unknown-dim-indicator',

    template: require('./template.hbs'),

    onRender: Backbone.View.prototype.unwrap,

    serializeData: function() {

        var isGOS = this.model.isGOS(),
            isCold = this.model.isCold();

        return {
            printPreview: markupPrintPreview,
            titleMsg: isGOS
                ? 'First Page Preview'
                : isCold
                    ? 'Image of Text' + '\n' + 'Includes Overlay and Offsets'
                    : '' // TODO: message for any other types?
        };
    }

});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/page/unknownDimIndicator/view.js
 ** module id = 421
 ** module chunks = 0
 **/